<template>
  <smd-one-col-layout content-styles="view-pharmacy-orders-discount__content">
    <div :class="{'view-pharmacy-orders-discount__inner': desktopView}">
      <div class="smd-form__section">
        <div class="smd-form__col m-b-30">
          <div>
            <text-string label-id="txt096"/>
            <text-string label-id="txt098"/>
          </div>
          <smd-list-selection-panel v-if="!attachedIds.length"
                                    :has-text-string="true"
                                    @selected="addAttachedIdFile">
            <text-string slot="placeholder"
                         label-id="txt097"/>
            <span class="ns-icon-ico020 ns-large-icon" slot="icon">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
          </smd-list-selection-panel>

          <template v-else>
            <smd-list-selection-panel class="m-b-15"
                                      rightActionText="Remove"
                                      title="txt111"
                                      v-for="(id, index) in attachedIds"
                                      :has-text-string="true"
                                      :key="index"
                                      @remove="removeAttachedIdFileFn(index)">
              <text-string slot="title"
                           label-id="txt111"/>
              <span class="ns-icon-ico020 ns-large-icon" slot="icon">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
            </smd-list-selection-panel>
          </template>

          <smd-list-selection-panel v-if="attachedIds.length"
                                    :has-text-string="true"
                                    @selected="addAttachedIdFile">
            <text-string slot="placeholder"
                         label-id="txt356"/>
            <span class="ns-icon-ico019 ns-large-icon"
                  slot="icon">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
          </span>
          </smd-list-selection-panel>
        </div>
      </div>
      <div class="view-pharmacy-orders-discount__footer-btn m-t-75"
           v-if="desktopView">
        <div class="smd-form__row">
          <smd-btn section="10"
                   variant="left-enabled"
                   @click="setActiveStep($options.PHARMACY_ORDERS_PRESCRIPTION)">
            <text-string label-id="txt109"/>
          </smd-btn>
          <smd-btn section="10"
                   type="submit"
                   variant="right-blue-enabled"
                   @click="setActiveStep($options.PHARMACY_ORDERS_DELIVERY_DETAILS)">
            <text-string label-id="txt349"/>
          </smd-btn>
        </div>
      </div>
    </div>
    <div slot="bottom-nav"
         v-if="!desktopView">
      <div class="smd-form__row">
        <smd-btn section="2"
                 variant="left-enabled"
                 @click="setActiveStep($options.PHARMACY_ORDERS_PRESCRIPTION)">
          <text-string label-id="txt109"/>
        </smd-btn>
        <smd-btn section="2"
                 variant="right-blue-enabled"
                 @click="setActiveStep($options.PHARMACY_ORDERS_DELIVERY_DETAILS)">
          <text-string label-id="txt349"/>
        </smd-btn>
      </div>
    </div>
    <!--  hidden input for adding id  -->
    <input class="input-hidden"
           ref="id-input"
           type="file"
           @change="handleIdFileSelection"/>
  </smd-one-col-layout>
</template>

<script>
  import {PHARMACY_ORDERS_PRESCRIPTION, PHARMACY_ORDERS_DELIVERY_DETAILS} from '@/reference/pharmacy-order-steps'
  import SetActiveStepMixin from "@/mixins/set-active-step-mixin";
  import {mapFields} from "vuex-map-fields";
  import {mapMutations} from "vuex";
  import {MUTATE_REMOVE_ATTACHED_ID} from "@/store/types";
  import ModalPreviewFile from "@/modals/modal-preview-file";
  import GetElementString from '@/mixins/get-element-string';

  import {Reference} from "smd-vue-scaffold";

  export default {
    name: "view-pharmacy-orders-discount-new",
    mixins: [
      SetActiveStepMixin,
      GetElementString,
    ],
    computed: {
      ...mapFields({
        attachedIds: 'attachedIds',
        attachedPrescriptions: 'attachedPrescriptions',
        idFileView: 'idFileView',
        orderData: 'orderData',
        prescriptionFileView: 'prescriptionFileView',
      }),
    },
    methods: {
      ...mapMutations({
        removeAttachedId: MUTATE_REMOVE_ATTACHED_ID,
      }),
      addAttachedIdFile() {
        this.$refs['id-input'].click();
      },
      handleIdFileSelection() {
        const [file] = this.$refs['id-input'].files;

        // some WebViews fire change with an empty FileList on cancel; the preview
        // modal reads file.type, so opening it without a file throws
        if (!file) {
          return;
        }

        this.idFileView = file;

        this.previewFile(this.idFileView);
        this.$nextTick(() => {
          this.$refs['id-input'].value = '';
        })
      },
      previewFile(file) {
        this.$modal.open({
          component: ModalPreviewFile,
          size: Reference.SmdModalSizes.xs,
          position: !this.$isMobile ? 'auto-height detached' : '',
          props: {
            file: [file],
            title: this.getElementString('txt111')
          }
        })
      },
      removeAttachedIdFileFn(index) {
        this.removeAttachedId(index);
      },
    },
    props: {
      desktopView: {type: Boolean, default: false}
    },
    PHARMACY_ORDERS_PRESCRIPTION,
    PHARMACY_ORDERS_DELIVERY_DETAILS,
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .view-pharmacy-orders-discount__inner {
    @include box-shadow();
    @include border-radius();
    background: color(white);
    padding: space(base) space(xxxl) 0;
    position: relative;
    max-width: 900px;
    margin-right: space(xxl);

    @include responsive('max-width: 1023px') {
      margin-right: 0;
    }
    @include responsive('min-width: 1800px') {
      margin: 0 auto;
    }
  }

  .view-pharmacy-orders-discount__footer-btn {
    margin-left: -60px;
    margin-right: -60px;
  }

  .view-pharmacy-orders-discount__content {
    padding-bottom: space(xxl) !important;
    padding-top: space(xl) !important;
  }
</style>